import { API_DOMAIN, WorkshopLogin, APP_CODE } from "../../Constants";



import axios from "axios";

const axiosInstance = axios.create({
  baseURL: API_DOMAIN,
  timeout: 5000,
  headers: {
    contentType: "application/json",
    accept: "application/json, text/plain, application/vnd.ms-excel",
    appCd: APP_CODE,
    "Access-Control-Allow-Methods": "POST",
    "Access-Control-Allow-Origin": "*",
    sessionId: "",
    ssoId: null
  }
});

axiosInstance.interceptors.response.use(
  response => response,
  error => {

    if (error.response.status === 401) {
    }
    if (error.response.headers.session === "INVALID_SESSION") {
      window.location.href = WorkshopLogin
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
